module.exports = require('./helpers/bundle-url').getBundleURL('3x3zo') + "logo-dark.eefe0b7f.svg";